<template>
  <div class="container">
    <TopPanel>我的关注</TopPanel>
    <div class="authList">
      <author-follow-item
        v-for="(item, index) in followList"
        :key="index"
        :authorId="item.authorId"
        :name="item.name"
        :avatar="item.headPic"
        :typeName="item.typeName"
        :authorCompany="item.authorCompany"
        :followerNum="item.followerNum"
        class="item"
        @gotoAuthor="gotoAuthor(item.authorId)"
      ></author-follow-item>
    </div>
  </div>
</template>

<script>
import AuthorFollowItem from '@/components/Mine/AuthorFollowItem.vue'
import TopPanel from '@/components/Mine/TopPanel'
import { getAuthorList } from '@/api/author'
export default {
  name: 'Follow',
  components: { TopPanel, AuthorFollowItem },
  data() {
    return {
      followList: []
    }
  },
  created() {
    this.loadAuthorList()
  },
  methods: {
    async loadAuthorList() {
      var parm = { type: 1, pageSize: 100 }
      const res = await getAuthorList(parm)
      if (res && res.result.code === 0) {
        this.followList = res.detail.list
        console.log(this.followList)
      }
    },
    gotoAuthor(authorId) {
      this.$router.push('/author/' + authorId)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 828px;
  height: 1225px;
  background-color: #ffffff;
  border: solid 1px #ebebeb;
  margin-left: 30px;
  margin-top: 0px;
  display: flex;
  flex-direction: column;
}
.authList {
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
}
.item {
  margin-top: 30px;
}
</style>
